import React, { useContext } from 'react';

import { CompanyContext } from 'common/containers/CompanyContainer';
import { ParamsContext, RouterContext } from 'common/containers/RouterContainer';
import Tappable from 'common/Tappable';

import type { Company } from 'common/api/endpoints/companies';

import 'css/components/changelog/widget/_ChangelogWidgetHeader.scss';

const TransitionDuration = 250;

type Props = {
  navigatingBack: boolean;
  showDismissButton: boolean;
  onDismiss: () => void;
  onNavigateBackStart: () => void;
};

const ChangelogWidgetHeader = ({
  navigatingBack,
  showDismissButton,
  onDismiss,
  onNavigateBackStart,
}: Props) => {
  const company = useContext<Company>(CompanyContext);
  const router = useContext(RouterContext);
  const params = useContext(ParamsContext);

  const onBack = () => {
    setTimeout(() => {
      router.replace('/' + company._id);
    }, TransitionDuration);

    onNavigateBackStart();
  };

  return (
    <div className="changelogWidgetHeader">
      {!params.entryURLName || navigatingBack ? (
        <div className="buttonSpacer" />
      ) : (
        <Tappable onTap={onBack}>
          <div className="backButton">
            <div className="icon icon-chevron-left" />
          </div>
        </Tappable>
      )}
      <h1 className="heading">Latest Updates</h1>
      {!showDismissButton ? (
        <div className="buttonSpacer" />
      ) : (
        <Tappable onTap={onDismiss}>
          <div className="dismissButton">
            <div className="icon icon-thick-x" />
          </div>
        </Tappable>
      )}
    </div>
  );
};
export default ChangelogWidgetHeader;
